import React from 'react';
import { FileText, Zap } from 'lucide-react';

const BookkeepingWizardHeader = () => {
    return (
        <>
            <style>{`
                .wizard-header {
                    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 2rem;
                    margin-bottom: 2rem;
                    text-align: center;
                }
                
                .wizard-title {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 1rem;
                    font-size: 1.75rem;
                    font-weight: 700;
                    color: #1e293b;
                    margin-bottom: 0.75rem;
                }
                
                .wizard-subtitle {
                    font-size: 1rem;
                    color: #64748b;
                    line-height: 1.6;
                    max-width: 600px;
                    margin: 0 auto;
                }
                
                .wizard-features {
                    display: flex;
                    justify-content: center;
                    gap: 2rem;
                    margin-top: 1.5rem;
                    flex-wrap: wrap;
                }
                
                .feature-item {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    font-size: 0.875rem;
                    color: #475569;
                    background: white;
                    padding: 0.5rem 1rem;
                    border-radius: 20px;
                    border: 1px solid #e2e8f0;
                }
                
                .feature-icon {
                    color: #3b82f6;
                }
                
                @media (max-width: 768px) {
                    .wizard-header {
                        padding: 1.5rem;
                    }
                    
                    .wizard-title {
                        font-size: 1.5rem;
                        flex-direction: column;
                        gap: 0.5rem;
                    }
                    
                    .wizard-features {
                        flex-direction: column;
                        align-items: center;
                        gap: 0.75rem;
                    }
                }
            `}</style>

            <div className="wizard-header">
                <h1 className="wizard-title">
                    <FileText size={32} color="#3b82f6" />
                    Bokföringsguide
                </h1>
                <p className="wizard-subtitle">
                    Skapa professionella bokföringsposter snabbt och enkelt. Vår steg-för-steg guide hjälper dig att
                    bokföra korrekt med mallar, automatisk kontoplan och smart validering.
                </p>

                <div className="wizard-features">
                    <div className="feature-item">
                        <Zap size={16} className="feature-icon" />
                        Snabb & Enkel
                    </div>
                    <div className="feature-item">
                        <FileText size={16} className="feature-icon" />
                        Professionella Mallar
                    </div>
                    <div className="feature-item">
                        <FileText size={16} className="feature-icon" />
                        Automatisk Validering
                    </div>
                </div>
            </div>
        </>
    );
};

export default BookkeepingWizardHeader;